module.exports = __webpack_public_path__ + "static/media/webdesign.d58770c6.png";